import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { loadAppData } from './initialisation-thunks';

export interface InitState {
    pending: boolean;
    fulfilled: boolean;
    error?: { message: any; stack?: any };
}

const initialState: InitState = {
    pending: true,
    fulfilled: false,
};

const initilisationSlice = createSlice({
    name: 'init',
    initialState,
    reducers: {
        resetError: (state) => {
            state.error = undefined;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(loadAppData.pending, (state) => {
                state.pending = true;
                state.fulfilled = false;
            })
            .addCase(loadAppData.fulfilled, (state) => {
                state.pending = false;
                state.fulfilled = true;
            })
            .addCase(
                loadAppData.rejected,
                (state, payload: PayloadAction<any>) => {
                    console.log('has rejected with... ', payload);
                    state.pending = false;
                    state.fulfilled = false;
                    state.error = { message: 'Unable to load page...' };
                },
            );
    },
});

export const { resetError } = initilisationSlice.actions;

export const intialisationErrorSelector = (state: { init: InitState }) =>
    state.init.error;
export const appLoadedSelector = (state: { init: InitState }) =>
    state.init.pending;

export default initilisationSlice.reducer;
